export default __webpack_public_path__ + "static/media/Polly_9781843628224.8ef03d94.jpg";